<template lang='pug'>
    v-container(fluid fill-height).pa-0.categories-container
      //- dialogs
      //- create
      v-dialog( persistent  :value='createItemDialog' max-width='500px' transition="dialog-bottom-transition")
        create-item( @close="createItemDialog=false")
      //- update
      v-dialog( persistent :key='currentItem.id' :value='updateItemDialog'  max-width='500px'   transition="dialog-bottom-transition")
        update-item(:model ='currentItem' @close="updateItemDialog=false")
      //- content
      v-card.px-2.mt-1.categories-card(height="100%" width="100%")
        v-row(style="height: 100%;").justify-center
          v-col(cols='12').py-0
            //- Filter shops
            v-select.rounded-xl.mt-1(
              label='Tienda',
              elevation=0
              outlined
              :items='field.locations',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(slot='selection', slot-scope='data')
                    v-flex(xs2='')
                        v-avatar(size='25px')
                            img( style='object-fit:cover; max-width: 50px' :src='getImageShop(data.item.pictures.imageInput1)' )
                    v-flex.ml-1(style='font-size:10px;')
                        | {{ data.item.name }}
                template(slot='item', slot-scope='data')
                    v-avatar(size='25px')
                        img(style='object-fit:cover; max-width: 50px' :src='getImageShop(data.item.pictures.imageInput1)')
                    v-list-tile-content
                        v-list-tile-title(v-html='data.item.name')
            v-card.mt-0.px-3.grey-card(color="#e8edee" elevation=0)
              v-row.d-flex.justify-space-around.my-3
                h3(style="color: #008E95") CATEGORIAS
                v-btn.rounded-lg( small color="#008E95" dark @click="createItemDialog=true")
                  | Crear categoria
                  v-icon mdi-plus
              //- .category-list.my-5
              .d-flex.flex-row.justify-space-around
                v-btn(small :color="currentItem.name === 'ALL' ? '#008E95':''" @click="selectCategory({name: 'ALL', type: 'default'})") Todos
                v-btn(small :color="currentItem.name === 'HOT' ? '#008E95':''" @click="selectCategory({name: 'HOT', type: 'default'})") Más Vendidos
                v-btn(small :color="currentItem.name === 'SOLDOUT' ? '#008E95':''" @click="selectCategory({name: 'SOLDOUT', type: 'default'})") Agotados
              .categories-scroll
                //- div(v-for='(item, index) in Items' :class='currentItem.id === item.id ? "selected" : ""')
                  p {{item}}
                v-list-item.my-2( v-for='(item, index) in Items' :class='currentItem.id === item.id ? "selected" : ""' :key="item.id"  @click="selectCategory(item)" style="position: relative;")
                  v-list-item-avatar
                    v-img(:src="getImage(item.pictures.imageInput1)")
                  v-list-item-content
                    v-list-item-title(v-text="item.name" :style="currentItem === item ? 'color: #3eb9cb;' : ''")
                  v-list-item-icon(v-if="currentItem.id === item.id" :style="isMobile ? 'position: absolute; right: 5%; top: 10%': ''")
                    v-icon(color="cyan"  @click.stop="editItem(item)") mdi-pen
              //- v-row.my-5
                v-col.pa-0
                v-col.pa-0
                v-col.pa-0
                //- v-row(key='all' ).hover-cursor
                  .display-1(style="font-size: .9rem !important")
                //- v-row(key='hot' ).hover-cursor
                  .display-1(style="font-size: .9rem !important")
                //- v-row(key='soldout' ).hover-cursor
                  .display-1(style="font-size: .9rem !important")
              //- template(v-if="Items && (smallScreen || isMobile)")
                template(v-for="(item, index) in Items")
                  div(@click="selectCategory(item)" :class="currentItem === item ? 'category__selected' : ''").category
                    img(:src="getImage(item.pictures.imageInput1)").category__img
                    span.category__title {{item.name}}
              //- div(style="width: 100%")
                //- v-list(subheader="")
                  v-subheader Categorias
                  v-list-item( v-for='(item, index) in Items' :class='currentItem.id === item.id ? "selected" : ""' :key="item.id"  @click="selectCategory(item)" style="position: relative;")
                    v-list-item-avatar
                      v-img(:src="getImage(item.pictures.imageInput1)")
                    v-list-item-content
                      v-list-item-title(v-text="item.name" :style="currentItem === item ? 'color: #3eb9cb;' : ''")
                    v-list-item-icon(v-if="currentItem.id === item.id" :style="isMobile ? 'position: absolute; right: 5%; top: 10%': ''")
                      v-icon(color="cyan"  @click.stop="editItem(item)") mdi-pen
              //- div(:style="smallScreen ? 'display:flex':''")
                v-skeleton-loader(v-for="i in 3" type="list-item-avatar-two-line").mx-auto
</template>

<script>
  import { mapState } from 'vuex'
  import XLSX from 'xlsx'
  import CreateItem from './CreateCategory'
  import UpdateItem from './UpdateCategory'
  import moment from 'moment'

  // import allCategorys from '../../assets/icons/products.png'
  import allCategorys from '../../assets/icons/products.png'
  import trendiCategorys from '../../assets/icons/trending.png'
  import shopPlaceHolder from '../../assets/icons/shop.svg'
  import productPlaceHolder from '@/assets/icons/products.png'

  export default {
    components: {
      CreateItem: CreateItem,
      UpdateItem: UpdateItem,
    },
    filters: {

    },
    props: {
      inventory: {
        type: Array,
        default: () => {
          return []
        },
      },
      getProductStock: {
        type: Function,
        required: true,
      },
      getBundleStock: {
        type: Function,
        required: true,
      },
      getBundleCost: {
        type: Function,
        required: true,
      },
      getProductPrice: {
        type: Function,
        required: true,
      },
      totalTaxes: {
        type: Function,
        required: true,
      },
      getProductUtility: {
        type: Function,
        required: true,
      },
      getPorcentualProductUtility: {
        type: Function,
        required: true,
      },
      getProductSold: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        createItemDialog: false,
        updateItemDialog: false,
        currentLocation: null,
        allCategorys: allCategorys,
        trendiCategorys: trendiCategorys,
        productPlaceHolder: productPlaceHolder,
        shopPlaceHolder: shopPlaceHolder,
        list: {
          0: false,
          1: false,
          2: false,
        },
      }
    },
    computed: {
      ...mapState(['change']),
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      headers () {
        return [
          {
            sortable: false,
            text: 'Imagen',
            value: 'pictures.imageInput1',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Nombre',
            value: 'name',
            align: 'left',
          },

        ]
      },
      currentItem () {
        return this.$store.state.categories.currentItem
      },
      Items () {
        try {
          if (this.currentLocation) {
            return this.$store.state.categories.category_list.filter(category => !!this.currentLocation.categories.find(target => category.id === target.id))
          } else {
            return this.$store.state.categories.category_list
          }
        } catch (err) {
          // console.log('error', err)
          return this.$store.state.categories.category_list
        }
      },
      smallScreen () {
        return window.innerWidth < 1500 && window.innerWidth >= 1024
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    created () {
      this.fetch()
      this.currentLocation = this.$store.getters['shops/currentItem']
    },
    methods: {
      onexport () {
        const vm = this
        const products = []
        vm.inventory.forEach(element => {
          // console.log(vm.getProductStock(element), 'the element')
          const item = {}
          item.nombre = element.name
          item.tipo = element.type
          item.inventario = element.type !== 'bundle' ? vm.getProductStock(element).result : vm.getBundleStock(element).result
          item.inversion = element.type !== 'bundle' ? element.price.buy : vm.getBundleCost(element)
          item.venta = vm.getProductPrice(element)
          item.impuestos = vm.totalTaxes(element)
          item.utilidad = vm.getProductUtility(element)
          item.utilidad_porcentaje = vm.getPorcentualProductUtility(element)
          item.vendidos = vm.getProductSold(element) || 0
          products.push(item)
        })
        const date = (moment().format('YYYY-MM-DD')).split('-')
        const dateFormated = date[2] + '/' + date[1] + '/' + date[0]
        const fileName = 'inventario_' + dateFormated
        const xls = XLSX.utils.json_to_sheet(products)
        const wb = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, xls, 'productos') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, fileName + '.xlsx') // name of the file is 'book.xlsx'
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
          vm.currentLocation = null
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          vm.currentLocation = item
        })
      },
      selectCategory (item) {
        const vm = this
        vm.$store.dispatch('products/setQuery', '').then(() => {

        })
        vm.$store.dispatch('categories/setCurrentItem', item).then(() => {

        })
      },
      fetch () {
        const vm = this
        vm.$store.dispatch('categories/loadItems', 'categories').then(() => {})
      },
      editItem (item) {
        const vm = this
        // console.log(item)
        this.$store.dispatch('categories/setCurrentItem', item).then(function () {
          vm.updateItemDialog = true
        })
      },
      getImage (url) {
        if (url === '') {
          return allCategorys
        } else {
          return url
        }
      },
      getImageShop (url) {
        // console.log(url)
        if (url === '') {
          return shopPlaceHolder
        } else {
          return url
        }
      },
    },
  }
</script>
<style lang="scss">
  .categories-container{
     padding-top: 0;
    .categories-scroll{
      height: 80%;
      overflow-y: scroll;
    }
    .grey-card{
      height: 90%;
      contain: strict;
      margin-bottom: 0;
        margin-top:0;
    }
    @media(max-width: 790px){
      .categories-card{
        max-height: 240px;
        padding-bottom: 0;
        margin-bottom: 0;
      }
      .categories-scroll{
        display: flex !important;
        flex-direction: row !important;
        overflow-x: scroll !important;
        height: 50px;
      }
      .grey-card{
        height: 150px !important;
      }
    }
    @media(min-width: 820px) and (max-width: 920px) {
      .categories-scroll{
        display: flex !important;
        flex-direction: row !important;
        overflow-x: scroll !important;
      }
      .grey-card{
        height: 70% !important;
      }
    }
  }
    .hover-cursor{
        cursor:pointer;
    }

    .category-list{
      margin: 0 auto;

      @media (max-width: 1500px){
        overflow-x: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        max-width: 100%;
        margin-left: 0.6rem;
      }

      &__item{
        @media (max-width: 600px){
          flex-wrap: wrap;
          display: flex;
          flex-direction:column;
        }
      }
    }

    .category {
      border-radius: 10px;
      display: block;
      text-align: center;
      @media (max-width: 1500px) and (min-width: 1024px) {
        display: inline-block;
        margin: 0 0.7rem;
        padding: 0 0.4rem;
        min-width: 4rem;

        &__selected {
          background: white;
        }
      }
      @media (max-width: 1024px) {
        &__selected {
          color: #3eb9cb;
        }
      }

      @media (max-width: 1024px) {
        border-radius: 0px;
        display: inline-block;
        margin: 0 0.7rem;
        min-width: 4rem;
      }

      &__img {
        display: block;
        height: 5.125rem;
        width: 5.125rem;
        object-fit: cover;
        margin: auto;
        box-shadow: 1px 3px 3px rgba(0,0,0,0.3);
        border-radius: 10px;
        @media (max-width: 1500px) and (min-width: 1024px) {
          height: 3.5rem;
          width: 3.5rem;
        }

        @media (max-width: 1024px) {
          border-radius: 50%;
          height: 3.5rem;
          width: 3.5rem;
        }
      }

      &__title {
        margin: 0.5rem 0 0 0;
        display: block;
        font-size: 0.7rem;
        @media (max-width: 1500px) and (min-width: 1024px) {
          margin-top: 0.4rem;
          max-width: 4rem;
          display: inline-flex;
        }
      }
    }
</style>
